var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "modal" } }, [
    _vm.item.name
      ? _c("div", { staticClass: "modal-mask" }, [
          _c(
            "div",
            {
              staticClass: "modal-wrapper",
              on: {
                click: function ($event) {
                  return _vm.close($event)
                },
              },
            },
            [
              _c("div", { staticClass: "modal-container" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h3", [_vm._v(_vm._s(_vm.item.name))]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn-close-modal",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", [
                    _c("div", { staticClass: "catalog catalog_view_detail" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "catalog__product-info product product_view_card",
                        },
                        [
                          _c("div", { staticClass: "product__content-inner" }, [
                            _c("div", { staticClass: "product__picture" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "product__picture-slider js-slider-preview-product-withThumb",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "product__picture-slider-main",
                                      attrs: { "data-slider": "main" },
                                    },
                                    [
                                      _vm.item.images.large &&
                                      _vm.item.images.large.length > 0
                                        ? [
                                            _c("vue-swiper", {
                                              key: _vm.item.id,
                                              attrs: {
                                                images: _vm.item.images.large,
                                              },
                                            }),
                                          ]
                                        : [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "thumb-image img-content",
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: "/img/empty-600.png",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ],
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "product__picture-slider-thumbs",
                                  }),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }